export const DEFAULT_EDITOR_PERMISSIONS = [
  'dashboard.read',
  'services.read', 'services.write',
  'projects.read', 'projects.write',
  'metrics.read', 'metrics.write',
  'faqs.read', 'faqs.write',
  'clients.read', 'clients.write',
  'partners.read', 'partners.write',
  'menu_items.read', 'menu_items.write',
  'messages.read', 'messages.write',
  'settings.read',
] as const;
